/*open drawer size chart */
function openDrawer(id) {
  const drawer = document.getElementById(id);

  // Agar yeh drawer already open hai → kuch na karo
  if (drawer.classList.contains("active")) return;

  // Sab drawers close karo
  const allDrawers = document.querySelectorAll(".drawer-overlay");
  allDrawers.forEach(d => d.classList.remove("active"));

  // Selected drawer open karo
  drawer.classList.add("active");
  document.body.classList.add("drawer-open");

  // Overlay click par close
  const overlay = drawer.querySelector(".drawer_over_lay");
  if (overlay) {
    overlay.onclick = function() {
      closeDrawer(id);
    };
  }
}

function closeDrawer(id) {
  const drawer = document.getElementById(id);
  drawer.classList.remove("active");

  // Check karo koi drawer open hai ya nahi
  const anyOpen = document.querySelector(".drawer-overlay.active");
  if (!anyOpen) {
    document.body.classList.remove("drawer-open");
  }
}

document.addEventListener("DOMContentLoaded", function() {

  function syncField(drawerId, hiddenId) {
    const drawerInput = document.getElementById(drawerId);
    const hiddenInput = document.getElementById(hiddenId);

    if (drawerInput && hiddenInput) {
      drawerInput.addEventListener("input", function() {
        hiddenInput.value = this.value;
      });
    }
  }

  // Text fields sync
  syncField("drawer-chest", "hidden-chest");
  syncField("drawer-sleeves", "hidden-sleeves");
  syncField("drawer-length", "hidden-length");
  syncField("drawer-shoulder", "hidden-shoulder");


  // 🔥 Image Sync (IMPORTANT PART)
  const drawerFile = document.getElementById("custom-image");
  const hiddenFile = document.getElementById("hidden-image");

  if (drawerFile && hiddenFile) {
    drawerFile.addEventListener("change", function() {
      hiddenFile.files = drawerFile.files;
    });
  }

});

/* add to crt drawer */
document.addEventListener('click', function (e) {

  // ========================
  // 1️⃣ OPTION SELECT LOGIC
  // ========================
  if (e.target.classList.contains('option-value')) {

    const optionBlock = e.target.closest('.option-block-1, .option-block-2');
    if (!optionBlock) return;

    const productContainer = e.target.closest('.product');
    if (!productContainer) return;

    const shopBtn = productContainer.querySelector('.shop-btn');

    // Get stored selections
    let selectedOption1 = productContainer.dataset.selectedOption1 || '';
    let selectedOption2 = productContainer.dataset.selectedOption2 || '';

    // OPTION BLOCK 1
    if (optionBlock.classList.contains('option-block-1')) {
      optionBlock.querySelectorAll('.option-value').forEach(el =>
        el.classList.remove('active')
      );
      e.target.classList.add('active');
      selectedOption1 =
        e.target.getAttribute('value') || e.target.innerText.trim();
    }

    // OPTION BLOCK 2
    if (optionBlock.classList.contains('option-block-2')) {
      optionBlock.querySelectorAll('.option-value').forEach(el =>
        el.classList.remove('active')
      );
      e.target.classList.add('active');
      selectedOption2 =
        e.target.getAttribute('value') || e.target.innerText.trim();
    }

    // Save selections on product
    productContainer.dataset.selectedOption1 = selectedOption1;
    productContainer.dataset.selectedOption2 = selectedOption2;

    // Match variant
    if (selectedOption1 && selectedOption2) {
      const selectedCombination = `${selectedOption1} / ${selectedOption2}`;

      const matchedVariant = [...productContainer.querySelectorAll('.variant-item')]
        .find(el => el.dataset.combination === selectedCombination);

      if (matchedVariant) {
        const variantId = matchedVariant.dataset.variantId;

        // Save variant id
        productContainer.dataset.variantId = variantId;

        // Update button value
        if (shopBtn) {
          shopBtn.value = variantId;
          shopBtn.disabled = false;
        }

        console.log('✅ Variant selected:', variantId);
      } else {
        console.log('❌ No matching variant');
        if (shopBtn) shopBtn.disabled = true;
      }
    }

    return; // stop further execution
  }

  // ========================
  // 2️⃣ SHOP BUTTON CLICK LOGIC
  // ========================
  if (e.target.classList.contains('shop-btn')) {
    e.preventDefault();

    const button = e.target;
    const variantId = button.value;

    if (!variantId) {
      alert('Please select product options first');
      return;
    }

    // Add to cart (AJAX)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(() => {
        openCartDrawer();
        updateHeaderCartCountSection();
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        alert('There was an error adding the product to the cart.');
      });
  }

});

// ========================
// 3️⃣ OPEN CART DRAWER
// ========================

function openCartDrawer() {

  fetch('/?sections=cart-drawer')
    .then(res => res.json())
    .then(data => {

      const parser = new DOMParser();
      const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');

      const newDrawer = newDoc.querySelector('.drawer');
      const currentDrawer = document.querySelector('.drawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        currentDrawer.classList.add('active');
        currentDrawer.classList.remove('is-empty');
      }

      // IMPORTANT: trigger cart update event
      document.dispatchEvent(new CustomEvent('cart:updated'));

    })
    .catch(err => console.error(err));
}

// ========================
// 4️⃣ UPDATE HEADER CART COUNT
// ========================
function updateHeaderCartCountSection() {
  fetch('/?section_id=header')
    .then(res => res.text())
    .then(html => {
      const newDoc = new DOMParser().parseFromString(html, 'text/html');
      const newBubble = newDoc.querySelector('.cart-count-bubble');
      const oldBubble = document.querySelector('.cart-count-bubble');

      if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
    });
}

/* grid collection */

// document.addEventListener('DOMContentLoaded', function () {

//   const buttons = document.querySelectorAll('.grid_show');
//   const grid = document.getElementById('product-grid');

//   function setActiveButton() {

//     // remove sabse active
//     buttons.forEach(b => b.classList.remove('active'));

//     let activeBtn;

//     // 👉 Mobile (748px se chhota)
//     if (window.innerWidth <= 748) {
//       activeBtn = buttons[0]; // first
//     } else {
//       activeBtn = buttons[buttons.length - 1]; // last
//     }

//     // 👉 Active set karo
//     activeBtn.classList.add('active');

//     // 👉 Grid class update
//     grid.classList.remove(
//       'grid--1-col-desktop',
//       'grid--2-col-desktop',
//       'grid--3-col-desktop',
//       'grid--4-col-desktop'
//     );

//     let cols = activeBtn.classList[1].split('-')[1];
//     grid.classList.add(`grid--${cols}-col-desktop`);
//   }

//   // 👉 Page load pe run
//   setActiveButton();

//   // 👉 Resize pe bhi change ho
//   window.addEventListener('resize', setActiveButton);

//   // 👉 Click event (normal behavior)
//   buttons.forEach(btn => {
//     btn.addEventListener('click', function () {

//       grid.classList.remove(
//         'grid--1-col-desktop',
//         'grid--2-col-desktop',
//         'grid--3-col-desktop',
//         'grid--4-col-desktop'
//       );

//       let cols = this.classList[1].split('-')[1];
//       grid.classList.add(`grid--${cols}-col-desktop`);

//       buttons.forEach(b => b.classList.remove('active'));
//       this.classList.add('active');

//     });
//   });

// });



document.addEventListener('DOMContentLoaded', function () {

  const buttons = document.querySelectorAll('.grid_show');
  const grid = document.getElementById('product-grid');

  // 👉 Last button ko default active karo
  const lastBtn = buttons[buttons.length - 1];
  lastBtn.classList.add('active');

  // 👉 Default grid bhi set karo (last button ke hisaab se)
  let defaultCols = lastBtn.classList[1].split('-')[1];
  grid.classList.add(`grid--${defaultCols}-col-desktop`);

  // 👉 Click event
  buttons.forEach(btn => {
    btn.addEventListener('click', function () {

      // Remove old grid classes
      grid.classList.remove(
        'grid--1-col-desktop',
        'grid--2-col-desktop',
        'grid--3-col-desktop',
        'grid--4-col-desktop'
      );

      // Add new grid class
      let cols = this.classList[1].split('-')[1];
      grid.classList.add(`grid--${cols}-col-desktop`);

      // Active class handle
      buttons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

    });
  });

});

